import { render } from "./ContactBlock.vue?vue&type=template&id=f6dbbd04&scoped=true"
import script from "./ContactBlock.vue?vue&type=script&lang=js"
export * from "./ContactBlock.vue?vue&type=script&lang=js"

import "./ContactBlock.vue?vue&type=style&index=0&id=f6dbbd04&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6dbbd04"]])

export default __exports__